/* OPD sale card and cart drawer preview, unpublished theme only */
(function () {
  "use strict";

  document.documentElement.classList.add("opd-sale-cart-ready");

  var optionsLayer = null;
  var activeProduct = null;
  var activeVariant = null;
  var lastFocus = null;

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD"
    }).format(Number(cents || 0) / 100);
  }

  function ensureOptionsDrawer() {
    if (optionsLayer) return optionsLayer;

    var shell = document.createElement("div");
    shell.innerHTML =
      '<div class="opd-options-layer" data-opd-options-layer aria-hidden="true">' +
        '<button class="opd-options-scrim" type="button" data-opd-options-close aria-label="Close options"></button>' +
        '<aside class="opd-options-drawer" role="dialog" aria-modal="true" aria-labelledby="opd-options-title" tabindex="-1">' +
          '<header class="opd-options-head">' +
            '<div><p class="opd-options-label">Choose your setup</p><h2 class="opd-options-title" id="opd-options-title">Select an option</h2></div>' +
            '<button class="opd-options-close" type="button" data-opd-options-close aria-label="Close options">&times;</button>' +
          '</header>' +
          '<div class="opd-options-body">' +
            '<div class="opd-options-product">' +
              '<img data-opd-options-image src="" alt="">' +
              '<div><p class="opd-options-product-name" data-opd-options-name></p><p class="opd-options-vendor" data-opd-options-vendor></p></div>' +
            '</div>' +
            '<fieldset class="opd-options-fieldset">' +
              '<legend>Available options</legend>' +
              '<div class="opd-options-list" data-opd-options-list></div>' +
            '</fieldset>' +
            '<p class="opd-options-error" data-opd-options-error role="alert" hidden></p>' +
          '</div>' +
          '<footer class="opd-options-foot">' +
            '<div class="opd-options-total"><span>Selected</span><strong data-opd-options-price></strong></div>' +
            '<button class="btn btn--full opd-options-add" type="button" data-opd-options-add>Add selected to cart</button>' +
            '<button class="opd-options-keep-shopping" type="button" data-opd-options-close>Keep browsing</button>' +
          '</footer>' +
        '</aside>' +
      '</div>';

    optionsLayer = shell.firstElementChild;
    document.body.appendChild(optionsLayer);

    optionsLayer.addEventListener("click", function (event) {
      var closeControl = event.target.closest("[data-opd-options-close]");
      if (closeControl) {
        closeOptionsDrawer(true);
        return;
      }

      var variantButton = event.target.closest("[data-opd-variant-id]");
      if (variantButton && !variantButton.disabled) {
        selectVariant(variantButton.getAttribute("data-opd-variant-id"));
      }
    });

    optionsLayer.querySelector("[data-opd-options-add]").addEventListener("click", function () {
      addSelectedVariant(this);
    });

    return optionsLayer;
  }

  function selectVariant(id) {
    if (!activeProduct) return;

    activeVariant = activeProduct.variants.find(function (variant) {
      return String(variant.id) === String(id);
    });

    if (!activeVariant) return;

    optionsLayer.querySelectorAll("[data-opd-variant-id]").forEach(function (button) {
      var selected = button.getAttribute("data-opd-variant-id") === String(activeVariant.id);
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    optionsLayer.querySelector("[data-opd-options-price]").textContent = formatMoney(activeVariant.price);
    optionsLayer.querySelector("[data-opd-options-add]").disabled = !activeVariant.available;
  }

  function renderOptions(product, requireSelection) {
    var layer = ensureOptionsDrawer();
    var image = layer.querySelector("[data-opd-options-image]");
    image.src = product.image || "";
    image.alt = product.title || "Product image";
    image.hidden = !product.image;
    layer.querySelector("[data-opd-options-name]").textContent = product.title || "Select an option";
    layer.querySelector("[data-opd-options-vendor]").textContent = product.vendor || "";
    layer.querySelector("[data-opd-options-error]").hidden = true;

    var list = layer.querySelector("[data-opd-options-list]");
    list.textContent = "";

    product.variants.forEach(function (variant) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "opd-variant-option";
      button.setAttribute("data-opd-variant-id", variant.id);
      button.setAttribute("aria-pressed", "false");
      button.disabled = !variant.available;

      var label = document.createElement("span");
      label.textContent = variant.title;
      var meta = document.createElement("small");
      meta.textContent = variant.available ? formatMoney(variant.price) : "Sold out";
      button.appendChild(label);
      button.appendChild(meta);
      list.appendChild(button);
    });

    if (requireSelection) {
      activeVariant = null;
      layer.querySelector("[data-opd-options-price]").textContent = product.chooseOptionsLabel || "Select an option";
      layer.querySelector("[data-opd-options-add]").disabled = true;
    } else {
      var firstAvailable = product.variants.find(function (variant) { return variant.available; });
      selectVariant(firstAvailable ? firstAvailable.id : product.variants[0].id);
    }
  }

  function openOptionsDrawer(button) {
    var card = button.closest(".grid-product, [data-opd-product-card]");
    var dataNode = card && card.querySelector("[data-opd-grid-product-json]");
    if (!dataNode) return false;

    try {
      activeProduct = JSON.parse(dataNode.textContent);
    } catch (error) {
      return false;
    }

    if (!activeProduct.variants || !activeProduct.variants.length) return false;

    lastFocus = button;
    renderOptions(activeProduct, button.hasAttribute("data-opd-require-selection"));
    ensureOptionsDrawer().classList.add("is-open");
    optionsLayer.setAttribute("aria-hidden", "false");
    document.body.classList.add("opd-options-open");
    window.requestAnimationFrame(function () {
      optionsLayer.querySelector(".opd-options-drawer").focus();
    });
    return true;
  }

  function closeOptionsDrawer(restoreFocus) {
    if (!optionsLayer) return;
    optionsLayer.classList.remove("is-open");
    optionsLayer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("opd-options-open");

    if (restoreFocus && lastFocus) lastFocus.focus();
  }

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    return "/cart/add.js";
  }

  function postVariant(parameters) {
    return fetch(cartAddUrl(), {
      method: "POST",
      body: parameters,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status === 422) throw data;
        return data;
      });
    });
  }

  function dispatchAdded(source, product, button) {
    source.dispatchEvent(new CustomEvent("ajaxProduct:added", {
      detail: { product: product, addToCartBtn: button },
      bubbles: true
    }));
  }

  function addSelectedVariant(button) {
    if (!activeVariant || !activeVariant.available || button.disabled) return;

    var errorNode = optionsLayer.querySelector("[data-opd-options-error]");
    errorNode.hidden = true;
    button.disabled = true;
    button.classList.add("btn--loading");

    var parameters = new URLSearchParams();
    parameters.set("id", activeVariant.id);
    parameters.set("quantity", "1");

    postVariant(parameters)
      .then(function (product) {
        closeOptionsDrawer(false);
        dispatchAdded(document, product, button);
      })
      .catch(function (error) {
        var message = error && (error.description || error.message)
          ? (error.description || error.message)
          : "This option could not be added. Please try again.";
        errorNode.textContent = typeof message === "string" ? message : "This option could not be added. Please try again.";
        errorNode.hidden = false;
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove("btn--loading");
      });
  }

  document.addEventListener("click", async function (event) {
    var optionsButton = event.target.closest("[data-opd-grid-options], .opd-card-action a.opd-grid-action");
    if (!optionsButton || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var isOptions = optionsButton.hasAttribute("data-opd-grid-options") || /choose options/i.test(optionsButton.textContent);
    if (!isOptions) return;
    event.preventDefault();
    event.stopPropagation();
    if (openOptionsDrawer(optionsButton)) return;
    var card = optionsButton.closest(".grid-product");
    var handle = card && card.getAttribute("data-product-handle");
    var fallback = optionsButton.getAttribute("href");
    if (!handle) { if (fallback) window.location.assign(fallback); return; }
    if (optionsButton.getAttribute("aria-busy") === "true") return;
    optionsButton.setAttribute("aria-busy", "true");
    try {
      var response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "products/" + encodeURIComponent(handle) + ".js", {credentials:"same-origin"});
      if (!response.ok) throw new Error("Product unavailable");
      var product = await response.json();
      if (!product.variants || !product.variants.length) throw new Error("Options unavailable");
      activeProduct = product;
      activeProduct.image = product.featured_image || (product.images && product.images[0]) || "";
      lastFocus = optionsButton;
      renderOptions(activeProduct, true);
      ensureOptionsDrawer().classList.add("is-open");
      optionsLayer.setAttribute("aria-hidden", "false");
      document.body.classList.add("opd-options-open");
      requestAnimationFrame(function () { optionsLayer.querySelector(".opd-options-drawer").focus(); });
    } catch (error) {
      if (fallback) window.location.assign(fallback);
    } finally {
      optionsButton.removeAttribute("aria-busy");
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    if (!optionsLayer || !optionsLayer.classList.contains("is-open")) return;

    if (event.key === "Escape") {
      event.preventDefault();
      closeOptionsDrawer(true);
      return;
    }

    if (event.key !== "Tab") return;

    var focusable = Array.prototype.slice.call(optionsLayer.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) { return element.offsetParent !== null; });

    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-opd-grid-add]");
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    var button = form.querySelector("[data-opd-grid-add-button]");
    if (!button || button.disabled) return;

    var originalText = button.textContent.trim();
    var previousError = form.querySelector(".opd-card-error");
    if (previousError) previousError.remove();

    button.disabled = true;
    button.classList.add("btn--loading");

    postVariant(new URLSearchParams(new FormData(form)))
      .then(function (product) {
        button.textContent = "ADDED";
        dispatchAdded(form, product, button);
        window.setTimeout(function () {
          button.textContent = originalText;
        }, 1600);
      })
      .catch(function (error) {
        var message = error && (error.description || error.message)
          ? (error.description || error.message)
          : "This item could not be added. Please try again.";
        var errorNode = document.createElement("p");
        errorNode.className = "opd-card-error";
        errorNode.setAttribute("role", "alert");
        errorNode.textContent = typeof message === "string" ? message : "This item could not be added. Please try again.";
        form.appendChild(errorNode);
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove("btn--loading");
      });
  }, true);
})();

